/// <amd-module name="VSS/Redux/Modules/VSSPageData/VSSPageDataActions" />
import { IPageData } from "VSS/Platform/Page";
import { createAction, ActionsUnion } from "redux/Utils/ActionHelper";

export const enum VSSPageDataActionTypes {
    InitializeVSSPageData = "VSSPageData/Initialize"
}

export const VSSPageDataActions = {
    initialize: (pageData: IPageData) => createAction(VSSPageDataActionTypes.InitializeVSSPageData, pageData)
};

export type VSSPageDataActions = ActionsUnion<typeof VSSPageDataActions>;
